import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  get_card_products,
  delete_card_product,
  messageClear,
  quantity_inc,
  quantity_dec,
  updateCustomization,
} from "../store/reducers/cardReducer";
import { FaTrash } from "react-icons/fa";
import { MdOutlineShoppingCartCheckout } from "react-icons/md";

const Card = () => {
  const dispatch = useDispatch();
  const navegate = useNavigate();
  const { userInfo } = useSelector((state) => state.auth);
  const {
    card_products,
    successMessage,
    price,
    buy_product_item,
    shipping_fee,
    outofstock_products,
  } = useSelector((state) => state.card);

  const redirect = () => {
    navegate("/shipping", {
      state: {
        products: card_products,
        price: price,
        shipping_fee: shipping_fee,
        items: buy_product_item,
      },
    });
  };
  useEffect(() => {
    dispatch(get_card_products(userInfo.id));
  }, []);

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
      dispatch(get_card_products(userInfo.id));
    }
  }, [successMessage]);

  const inc = (quantity, stock, card_id) => {
    const temp = quantity + 1;
    if (temp <= stock) {
      dispatch(quantity_inc(card_id));
    }
  };

  const dec = (quantity, card_id) => {
    const temp = quantity - 1;
    if (temp !== 0) {
      dispatch(quantity_dec(card_id));
    }
  };

  const handleLinkClick = (pt) => {
    if (pt.customization) {
      // Dispatch the updateCustomization action with the customization data
      dispatch(updateCustomization(pt.customization));
    }
    // Navigate to the appropriate route with state including product ID and customization
    navegate(
      pt.customization
        ? "/product/details/Customize"
        : `/product/details/${pt.productInfo.slug}`,
      {
        state: {
          customization: pt.customization,
          productId: pt.productInfo._id,
          product: pt.productInfo,
        },
      }
    );
  };

  return (
    <div>
      <Headers />
      <section
        className=" md:hidden h-[220px]  bg-cover bg-no-repeat relative bg-left"
        style={{ backgroundImage: `url(/images/banner/cart.jpg)` }}
      >
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white">
              <h2 className="text-3xl font-bold">Ariz Supermart</h2>
              <div className="flex justify-center items-center gap-2 text-2xl w-full">
                <span>Cart</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bg-[whitesmoke]">
        <div className="w-[85%] lg:w-[90%] md:w-[90%] sm:w-[90] mx-auto py-16">
          {card_products.length > 0 || outofstock_products.length > 0 ? (
            <div className="flex flex-wrap">
              <div className="w-[67%] md-lg:w-full">
                <div className="pr-3 md-lg:pr-0">
                  <div className="flex flex-col gap-3">
                    <div className=" p-4  rounded-full">
                      <h2 className="text-md text-slate-700 font-semibold">
                        My Cart ({card_products.length})
                      </h2>
                    </div>
                    {card_products.map((p, i) => (
                      <div className="flex bg-white rounded-xl drop-shadow-md p-4 flex-col gap-2">
                        <div className="flex justify-start items-center">
                          <h2 className="text-md font-semibold text-slate-600">
                            {p.shopName}
                          </h2>
                        </div>
                        {p.products.map((pt, i) => (
                          <div className="w-full flex flex-wrap">
                            <div className="flex sm:w-full gap-2 w-7/12">
                              <div
                                onClick={() => handleLinkClick(pt)}
                                className="cursor-pointer flex gap-2 justify-start items-center"
                              >
                                <img
                                  className="w-[80px] h-[80px] rounded-xl"
                                  src={pt.productInfo.images[0]}
                                  alt="product image"
                                />
                                <div className="pr-4 ">
                                  <h2 className="text-md text-slate-700">
                                    {pt.productInfo.name}
                                  </h2>
                                  <span className="text-sm text-slate-500">
                                    Brand: {pt.productInfo.brand}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="flex justify-between items-center w-5/12 sm:w-full sm:mt-3 xs:hidden">
                              <div className="pl-4 sm:pl-0">
                                {pt.productInfo.discount > 0 ? (
                                  <>
                                    <h2 className="text-lg text-primaryLight">
                                      Rs.
                                      {pt.productInfo.price -
                                        Math.floor(
                                          (pt.productInfo.price *
                                            pt.productInfo.discount) /
                                            100
                                        )}{" "}
                                      {pt.customization
                                        ? "+ " +
                                          pt.customization?.customizationPrize
                                        : ""}
                                    </h2>
                                    <div>
                                      <span className="line-through">
                                        Rs.{pt.productInfo.price}
                                      </span>{" "}
                                      <span className="text-primaryLight">
                                        -{pt.productInfo.discount}%
                                      </span>
                                    </div>

                                    {pt.customization && <p>customized</p>}
                                  </>
                                ) : (
                                  <>
                                    <h2 className="text-lg text-primaryLight">
                                      Rs.{pt.productInfo.price}{" "}
                                      {pt.customization
                                        ? "+ " +
                                          pt.customization?.customizationPrize
                                        : ""}
                                    </h2>
                                    {pt.customization && (
                                      <p className="text-slate-500">
                                        customized
                                      </p>
                                    )}
                                  </>
                                )}
                              </div>
                              <div className="flex gap-2 flex-col">
                                {!pt.customization && (
                                  <div className="flex rounded-full bg-slate-200 h-[30px] justify-center items-center text-xl">
                                    <div
                                      onClick={() => dec(pt.quantity, pt._id)}
                                      className="px-3 cursor-pointer hover:text-indigo-800"
                                    >
                                      -
                                    </div>
                                    <div className="px-3">{pt.quantity}</div>
                                    <div
                                      onClick={() =>
                                        inc(
                                          pt.quantity,
                                          pt.productInfo.stock,
                                          pt._id
                                        )
                                      }
                                      className="px-3 cursor-pointer hover:text-indigo-800"
                                    >
                                      +
                                    </div>
                                  </div>
                                )}
                                <button
                                  onClick={() =>
                                    dispatch(delete_card_product(pt._id))
                                  }
                                  className="rounded-lg hover:shadow-red-500/20 hover:shadow-lg bg-red-500 relative justify-center cursor-pointer overflow-hidden flex items-center border border-red-500 bg-red-500 group hover:bg-red-500 active:bg-red-500 active:border-red-500"
                                >
                                  <span className="text-gray-200  px-5 py-[5px] text-sm transform group-hover:translate-x-20 transition-all duration-300">
                                    Delete
                                  </span>
                                  <span className="absolute right-0 h-full w-0 rounded-lg bg-red-500 flex items-center justify-center transform group-hover:translate-x-0 group-hover:w-full text-white transition-all duration-300">
                                    <FaTrash />
                                  </span>
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                    {outofstock_products.length > 0 && (
                      <div className="flex flex-col gap-3">
                        <div className=" rounded-full p-4">
                          <h2 className="text-md  text-red-500 font-semibold">
                            Expired ({outofstock_products.length})
                          </h2>
                        </div>
                        <div className="bg-white rounded-xl drop-shadow-md p-4">
                          {outofstock_products.map((p, i) => (
                            <div key={i} className="w-full flex flex-wrap">
                              <div className="flex  sm:w-full gap-2 w-4/12">
                                <div className="flex gap-2 justify-start items-center">
                                  <img
                                    className="w-[80px] h-[80px] opacity-70 rounded-[10px]"
                                    src={p.products[0].images[0]}
                                    alt="product image"
                                  />
                                  <div className="pr-4 text-slate-400">
                                    <h2 className="text-md">
                                      {p.products[0].name}
                                    </h2>
                                    <span className="text-sm">
                                      Brand : {p.products[0].brand}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="flex justify-between items-center w-8/12 sm:w-full sm:mt-3">
                                <div className="pl-4 sm:pl-0">
                                  <h2 className="text-lg text-red-500">
                                    This product is no longer available
                                  </h2>
                                </div>
                                <div className="flex gap-2 flex-col">
                                  <button
                                    onClick={() =>
                                      dispatch(delete_card_product(p._id))
                                    }
                                    className="rounded-lg hover:shadow-red-500/20 hover:shadow-lg bg-red-500 relative justify-center cursor-pointer overflow-hidden flex items-center border border-red-500 bg-red-500 group hover:bg-red-500 active:bg-red-500 active:border-red-500"
                                  >
                                    <span className="text-gray-200 text-sm px-5 py-[5px] transform group-hover:translate-x-20 transition-all duration-300">
                                      Delete
                                    </span>
                                    <span className="absolute right-0 h-full w-0 rounded-lg bg-red-500 flex items-center justify-center transform group-hover:translate-x-0 group-hover:w-full text-white transition-all duration-300">
                                      <FaTrash />
                                    </span>
                                  </button>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="w-[33%] md-lg:w-full">
                <div className="pl-3 md-lg:pl-0 md-lg:mt-5 md:pb-[20%]">
                  {card_products.length > 0 && (
                    <div className="bg-white mt-[16%] md-lg:mt-[0%] rounded-xl drop-shadow-md py-6 px-5 text-slate-600 flex flex-col gap-5">
                      <h2 className="text-xl text-[#212730] font-bold">
                        Order Summary
                      </h2>
                      <div className="flex justify-between items-center">
                        <span>Subtotal ({buy_product_item}) </span>
                        <span>Rs.{price}</span>
                      </div>
                      <div className="flex justify-between items-center">
                        <span>Shipping Fee</span>
                        <span>Rs.{shipping_fee}</span>
                      </div>
                      {/* <div className='flex gap-2'>
                                                <input className='w-full px-3 py-2 text-sm rounded-[10px] border border-slate-200 outline-0 focus:border-green-500' type="text" placeholder='DO YOU HAVE PROMO CODE?' />
                                                <button className='flex justify-center items-center px-5 py-[1px] rounded-[10px] bg-[#212730] text-white hover:shadow-blue-700/20 hover:shadow-lg  text-sm'>Apply < IoTicketOutline className='ml-1' /></button>
                                            </div> */}
                      <div className="w-[90] h-[2px] bg-[#212730] mt-3"></div>

                      <div className="flex justify-between font-semibold items-center">
                        <span>Total</span>
                        <span className="text-lg font-semibold text-slate-700">
                          Rs.{price + shipping_fee}
                        </span>
                      </div>
                      <button
                        onClick={redirect}
                        className=" flex justify-center items-center px-5 py-[6px] rounded-[10px] hover:shadow-green-700/20 hover:shadow-lg bg-secondary text-md text-white "
                      >
                        Proceed to checkout
                        <MdOutlineShoppingCartCheckout className="ml-2" />{" "}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="flex flex-col gap-3 items-center justify-center">
              <svg
                className="w-[60%] h-[250px]"
                viewBox="0 0 100 100"
                xmlns="http://www.w3.org/2000/svg"
                fill="#000000"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  {" "}
                  <path
                    fill="#ff700e"
                    d="M50 0c-27.614 0-50 22.387-50 50 0 27.615 22.386 50 50 50 27.613 0 50-22.385 50-50 0-27.613-22.387-50-50-50z"
                  ></path>{" "}
                  <path
                    fill="#212730"
                    d="M19.004 29.985h62.021v49.976h-61.959l-.062-49.976z"
                  ></path>{" "}
                  <g fill="#ffcc00">
                    {" "}
                    <path d="M84.003 42.015c0 .025-67.944-.02-68.008 0v37.919c.001.004-.007 2.999-.018 6.693 8.925 8.293 20.878 13.373 34.023 13.373 13.122 0 25.057-5.061 33.977-13.328-.031-3.709-.057-6.723-.055-6.724 0-15.728.081-37.933.081-37.933zM75.021 34.009v6.521l6.004-1.17v-9.375zM25.01 40.023v-6.014l-6.006-4.024v9.984z"></path>{" "}
                  </g>{" "}
                  <path
                    fill="#f39c12"
                    d="M25.01 42.015v-8.006l-9.015 8.006h9.015zm50.011-8.006v8.006h8.981l-8.981-8.006z"
                  ></path>{" "}
                  <path
                    fill="#ff700e"
                    d="M71.064 57.558c0-.838-.724-1.586-1.562-1.586s-1.649.748-1.649 1.586c-.004 10.158-7.641 18.393-17.8 18.393-10.16 0-17.996-8.233-18.001-18.393 0-.838-.71-1.586-1.549-1.586s-1.657.748-1.657 1.586c0 11.936 9.275 21.608 21.209 21.608 11.933 0 21.009-9.674 21.009-21.608z"
                  ></path>{" "}
                  <path
                    fill="#143d35"
                    d="M30.472 52.988c-1.37 0-2.48 1.11-2.48 2.48 0 1.369 1.11 2.479 2.48 2.479 1.37 0 2.512-1.11 2.512-2.479-.001-1.368-1.143-2.48-2.512-2.48zm39.001 0c-1.371 0-2.48 1.11-2.48 2.48 0 1.369 1.109 2.479 2.48 2.479 1.369 0 2.512-1.11 2.512-2.479-.003-1.368-1.144-2.48-2.512-2.48z"
                  ></path>{" "}
                  <path
                    fill="#ffffff"
                    d="M71.064 56.558c0-.838-.724-1.586-1.562-1.586s-1.649.748-1.649 1.586c-.004 10.158-7.641 18.393-17.8 18.393-10.16 0-17.996-8.233-18.001-18.393 0-.838-.71-1.586-1.549-1.586s-1.657.748-1.657 1.586c0 11.936 9.275 21.608 21.209 21.608 11.933 0 21.009-9.674 21.009-21.608z"
                  ></path>{" "}
                </g>
              </svg>
              <Link
                className="px-4 py-1 bg-secondary rounded-[10px] text-white"
                to="/shops"
              >
                Shop Now
              </Link>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Card;
